import pickBy from 'lodash-es/pickBy';
import isEmpty from 'lodash-es/isEmpty';
import identity from 'lodash-es/identity';
import { FacilitiesGroups } from 'ha/models/ListingFacilities/constants';
import { ListingFacilities } from '@ha/api/v2/types/Listing';

export type PreparedFacilities = {
  [x: string]: ListingFacilities;
};

const getFacilitiesByGroup = (facilities: ListingFacilities) => {
  const preparedFacilities: PreparedFacilities[] = [];

  Object.keys(FacilitiesGroups).forEach(group => {
    const preparedFacilityGroup = FacilitiesGroups[group].reduce(
      (obj: ListingFacilities, facility: string) => ({
        ...obj,
        [facility]: facilities[facility],
      }),
      {},
    );

    const cleanedNullFacilities = pickBy(preparedFacilityGroup, identity);

    if (!isEmpty(cleanedNullFacilities)) {
      preparedFacilities.push({ [group]: cleanedNullFacilities });
    }
  });

  return preparedFacilities;
};

export { getFacilitiesByGroup };
